export default __webpack_public_path__ + "static/media/dashboard-lab-icon.2a0f34a9.svg";